module.exports = __webpack_public_path__ + "img/img21.b339e5dd.svg";